(function ($) {
  $(document).ready(function () {
    const npsCalculator = 'nps';
    const calculatorConstants = {
      'nps': {
        'totalInvestment': { // in rupees
          default: 2000,
          min: 1000,
          max: 1000000,
        },
        'returnRate': {   // in %
          default: 10,
          min: 0,
          max: 40,
        },
        'timePeriod': {   // in yrs
          default: 35,
          min: 18,
          max: 55,
        }
      }
    };
    let totalInvestment = calculatorConstants[npsCalculator].totalInvestment.default;
    let returnRate = calculatorConstants[npsCalculator].returnRate.default;
    let timePeriod = calculatorConstants[npsCalculator].timePeriod.default;

    const totalInvestmentHTML = document.getElementById('total-investment');
    const interestHTML = document.getElementById('total-interest');

    const maturityHTML = document.getElementById('total-maturity');
    const annuityHTML = document.getElementById('total-min-annuity');



    let investedChart;
    let estChart;

    function updatenpsTextValues() {
      var p = Number(totalInvestment); // Invested amount
      var t = 60 - Number(timePeriod);
      const totalInvestmentNSP = p * 12 * t;
      const returnValue = calculate();
      const userInvestment = npsCalculator ? totalInvestment : totalInvestment * timePeriod * 12;
      totalInvestmentHTML.innerHTML = '₹ ' + Number(Math.round(totalInvestmentNSP, 2)).toLocaleString('en-IN');
      interestHTML.innerHTML = '₹ ' + Number(Math.round(returnValue - totalInvestmentNSP, 2)).toLocaleString('en-IN');
      maturityHTML.innerHTML = '₹ ' + Number(Math.round(returnValue, 2)).toLocaleString('en-IN');
      annuityHTML.innerHTML = '₹ ' + Number(Math.round(returnValue * 0.4, 2)).toLocaleString('en-IN');
      investedChart = userInvestment;
      estChart = returnValue - userInvestment;
    }


    /**
     * Rangeslider.js initialization
     */
    $('input[type="range"]').rangeslider({
      polyfill: false,

      // Default CSS classes
      rangeClass: "rangeslider",
      disabledClass: "rangeslider--disabled",
      horizontalClass: "rangeslider--horizontal",
      verticalClass: "rangeslider--vertical",
      fillClass: "rangeslider__fill",
      handleClass: "rangeslider__handle",
      onInit: function () { },
      onSlide: function (position, value) { },
      onSlideEnd: function (position, value) { },

    });

    /**
     * Forces input value to stay within the range
     */
    function forceValueRanges(input, type, forceMin = false) {
      const value = Number(input.val());
      const allowedMax = calculatorConstants[npsCalculator][type].max;
      const allowedMin = calculatorConstants[npsCalculator][type].min;
      if (value > allowedMax) {
        input.val(allowedMax);
      }
      function forceMinValues() {
        if (value < allowedMin && value) {
          input.val(allowedMin);
        }
      }
      if (forceMin) {
        forceMinValues();
      }
    };

    /**
     * Input field listeners
     */
    $('input#total-investment-input').on('input', function (event) {
      forceValueRanges($('input#total-investment-input'), 'totalInvestment');
      totalInvestment = Number(event.target.value);
      $('input#total-investment-slider').val(totalInvestment).change();
    });
    $('input#return-rate-input').on('input', function (event) {

      forceValueRanges($('input#return-rate-input'), 'returnRate');

      returnRate = Number(event.target.value);
      $('input#return-rate-slider').val(returnRate).change();
    });
    $('input#period-input').on('input', function (event) {

      forceValueRanges($('input#period-input'), 'timePeriod');

      timePeriod = Number(event.target.value);
      $('input#period-input-slider').val(timePeriod).change();
    });
    /**
     * Slider input listeners
     */
    $('input#total-investment-slider').on('input', function (event) {
      totalInvestment = Number(event.target.value);
      if (totalInvestment > 0) {
        $('input#total-investment-input').val(totalInvestment);
      }
    });
    $('input#return-rate-slider').on('input', function (event) {
      returnRate = Number(event.target.value);
      $('input#return-rate-input').val(returnRate);
    });
    $('input#period-input-slider').on('input', function (event) {
      timePeriod = Number(event.target.value);
      $('input#period-input').val(timePeriod);
    });

    $("input[type=number]").on("keydown", function (e) {
      let invalidChars = ["-", "+", "e"];
      if (invalidChars.includes(e.key)) {
        e.preventDefault();
      }
    });
    function calculatenpsReturn() {
      const r = Number(returnRate) * 0.01; //return %
      const p = Number(totalInvestment); // Invested amount
      const t = 60 - Number(timePeriod);
      let TotalNPS = p * ((Math.pow((1 + (r / 12)), 12 * t) - 1) / (r / 12));
      if (isNaN(TotalNPS)) {
        TotalNPS = 0;
      }
      return Math.round(TotalNPS);
    }

    $(document).on('input', function () {   
      updateTextValues();
    });

    function updateTextValues() {
      return updatenpsTextValues();

    }

    function calculate() {
      return calculatenpsReturn();
    }

    function init() {
      updateTextValues();
    }

    init();

  });
})(jQuery);